import { autoinject, transient } from "aurelia-framework";
import { EntityCommentModel } from "../../../../models/entity-comment/entity-comment.models";
import { SignalClientService } from '@rightship-tech/common-ui/services/basic/signal-client.service';
import { SignalFunctions } from "../../../../services/basics/signal-functions";
import { UserClientService } from "../../../../services/authentication/user-client.service";
import { EntityCommentService } from "../../../../services/entity-comment/entity-comment.service";
import { BindingSignaler } from "aurelia-templating-resources";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { RightShipDialogServiceConstants } from "../../../../constants/basics/rightship-dialog.constants";

@autoinject
@transient()
export class EntityComments {

    public isPrivate: boolean = true;
    public comment: string;
    public scroller: HTMLElement;
    public loadingMore: boolean = false;
    public loadedAll: boolean;
    public comments: EntityCommentModel[] = [];
    public canReadPrivateComments: boolean = true;
    public currentUserId: number;
    public canSubmit: boolean;
    public entityTypeId: number;
    public entityId: number;
    public item: any;
    public canEdit: boolean;
    public canDelete: boolean;

    constructor(private bindingSignaler: BindingSignaler,
        private signalClientService: SignalClientService,
        private entityCommentService: EntityCommentService,
        private dialogClientService: DialogClientService,
        private userClientService: UserClientService) {
        this.currentUserId = this.userClientService.currentUser.id;
    }

    protected activate(model: {
        canSubmit: boolean,
        entityTypeId: number,
        entityId: number,
        item: any
    }) {
        if(model) {
            this.item = model.item;
            this.entityTypeId = model.entityTypeId;
            this.entityId = model.entityId;
            this.canSubmit = model.canSubmit;
            this.loadMore(this.entityId, this.entityTypeId, 0, 10);
        }
    }


    attached() {
        this.signalClientService.subscribe(SignalFunctions.refreshComments, this.refreshComments);
    }

    detached() {
        this.signalClientService.unsubscribe(SignalFunctions.refreshComments, this.refreshComments);
    }

    async loadMore(entityId: number, entityTypeId: number, skip: number, take: number) {
        this.loadingMore = true;
        const comments = await this.entityCommentService.getComments(entityId, entityTypeId, take, skip);
        this.loadingMore = false;
        this.loadedAll = comments.length == 0;
        if (!this.comments) {
            this.comments = comments;
        }
        else {
            comments.forEach(comment => {
                if (!this.comments.some(c => c.entityCommentId == comment.entityCommentId)) {
                    this.comments.push(comment);
                }
            });
        }

        this.item["privateNotesCount"] = this.comments.length;

        this.bindingSignaler.signal('update-title');
    }

    async submit() {
        if (this.comment) {
            let div = document.createElement('div');
            div.innerHTML = this.comment;
            if (div.children.length) {
                await this.entityCommentService.addComment(this.entityId, this.entityTypeId, this.comment, this.isPrivate);
                this.comment = "";
            }
            div.remove();
            div = null;
        }
    }

    async onScroll() {

        const entityTypeId = this.entityTypeId;

        const entityId = this.entityId;

        if (this.loadingMore || this.loadedAll) {
            return;
        }

        if (Math.abs(this.scroller.scrollHeight - this.scroller.clientHeight - this.scroller.scrollTop) < 1) {
            await this.loadMore(entityId, entityTypeId, this.comments.length, 10);
        }
    }

    editComment(comment: EntityCommentModel) {
        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.EditCommentDialog, {
            id: comment.entityCommentId,
            notes: comment.comment,
            onCommentUpdated: (id: number, notes: string) => {
                const index = this.comments.findIndex(c => c.entityCommentId == id);
                this.comments[index].comment = notes;
            }
        }, true, false, false, 'right');
    }

    deleteComment(comment: EntityCommentModel) {
        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.DeleteCommentDialog, {
            id: comment.entityCommentId,
            onCommentDeleted: (id: number) => {
                const index = this.comments.findIndex(c => c.entityCommentId == id);
                this.comments.splice(index, 1);
            }
        }, true);
    }

    refreshComments = async (payload: any) => {
        if (this.entityId == payload.entityId && this.entityTypeId == payload.entityTypeId) {
            
            if (!this.comments) {
                this.comments = [];
            }

            if (!payload.isPrivate || this.canReadPrivateComments) {

                const exists = this.comments.some(c => c.entityCommentId == payload.entityCommentId);
                if (!exists) {
                    this.comments.splice(0, 0, payload);

                    this.item["privateNotesCount"] = this.comments.length;

                    this.bindingSignaler.signal('update-title');
                }

            }
        }
    }
}
